import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/node_modules/@mui/material/Box/Box.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/node_modules/@mui/material/Typography/Typography.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/src/components/common/broadsheet/link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/src/components/common/outlines/outlines.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/src/components/common/pages/social-icons/social-icons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/src/components/journal-site/_partials/header/journal-header.tsx");
